export const mutations = {
    SET_TOKEN: (state, token) => state.token = token,
    SET_ROLE: (state, role) => state.role = role,
    SET_OWNER_BRANCH: (state, owner_branch) => state.owner_branch = owner_branch,
    SET_BRANCHES: (state, branches) => state.branches = branches,
    SET_MODULES: (state, modules) => state.modules = modules,
    SET_NOTIFICATION: (state, notification) => state.notification = notification,
    SET_CURRENT_BRANCH: (state, current_branch) => state.current_branch = current_branch,
    SET_NAME: (state, name) => state.name = name,
    SET_PHONE: (state, phone) => state.phone = phone,
    SET_ID: (state, id) => state.id = id,
};